import React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import Typography from '@mui/material/Typography';
import moment from 'moment';

const StudentTimeline = (props = {}) => {
    const { studentProfile = {} } = props;
    const { student_id, studentId_generate_date, class_roll_number, classRoll_generate_date, is_registration_completed, payment_status: { total_fee_paid, documents_verified, isPaymentVerified, doc_verification_date, payment_date, isCollegeFeePaid, collegeFeesPaidDate, roll_no_generate_date, student_id_generate_date } = {}, roll_number, creation_date,
        reg_complete_date, examination_status :{is_examination_passed = false, update_date} = {}, entranceRollNumber } = studentProfile;

    const getColor = (param) => {
        if (param) {
            return '#06c406';
        }

        return '#ffa900';
    }

    const getDate = (da) => {
        if (da) {
            return moment(da).format('MMM DD YYYY h:mm A');
        }

        return '';
    }

    return (
        <div style={{display: 'flex', height: '100%', alignItems: 'end'}}>
            <Timeline
                sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0,
                    },
                }}
            >
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: '#06c406', height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: '#06c406', borderColor: '#06c406' }}>
                            <DoneOutlinedIcon />
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: '#06c406', height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>Create Account</Typography>
                        {creation_date && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(creation_date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: '#06c406', height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(is_registration_completed), borderColor: getColor(is_registration_completed) }}>
                            {is_registration_completed ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(is_registration_completed), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>Registration Completed</Typography>
                        {reg_complete_date?.date && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(reg_complete_date?.date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(isCollegeFeePaid), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(isCollegeFeePaid), borderColor: getColor(isCollegeFeePaid) }}>
                            {isCollegeFeePaid ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(isCollegeFeePaid), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>College Fees Payment Done</Typography>
                        {isCollegeFeePaid && collegeFeesPaidDate && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(collegeFeesPaidDate)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(isCollegeFeePaid), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(isCollegeFeePaid), borderColor: getColor(isCollegeFeePaid) }}>
                            {isCollegeFeePaid ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(isCollegeFeePaid), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>College Fees Verification Done</Typography>
                        {collegeFeesPaidDate && isCollegeFeePaid && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(collegeFeesPaidDate)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(entranceRollNumber), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(entranceRollNumber), borderColor: getColor(entranceRollNumber) }}>
                            {entranceRollNumber ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(entranceRollNumber), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>Entrance roll number Generated</Typography>
                        {(isCollegeFeePaid && collegeFeesPaidDate && entranceRollNumber) && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(collegeFeesPaidDate)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(is_examination_passed), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(is_examination_passed), borderColor: getColor(is_examination_passed) }}>
                            {is_examination_passed ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(is_examination_passed), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>Entrance Examination Passed</Typography>
                        {is_examination_passed && update_date && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(update_date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(total_fee_paid), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(total_fee_paid), borderColor: getColor(total_fee_paid) }}>
                            {total_fee_paid ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(total_fee_paid), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>Course/tuition fee Payment Done</Typography>
                        {isPaymentVerified && total_fee_paid && payment_date && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(payment_date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>
                
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(documents_verified), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(documents_verified), borderColor: getColor(documents_verified) }}>
                            {documents_verified ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(documents_verified), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography>Documents verification Done</Typography>
                        {doc_verification_date && documents_verified && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(doc_verification_date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(student_id), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(student_id), borderColor: getColor(student_id) }}>
                            {student_id ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(student_id), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto' }}>
                        <Typography>Student ID Generated</Typography>
                        {student_id && studentId_generate_date && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(studentId_generate_date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: getColor(class_roll_number), height: '7.5px' }} />
                        <TimelineDot variant="outlined" sx={{ color: getColor(class_roll_number), borderColor: getColor(class_roll_number) }}>
                            {class_roll_number ? <DoneOutlinedIcon /> : <PriorityHighOutlinedIcon />}
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: getColor(class_roll_number), height: '7.5px' }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2, m: 'auto' }}>
                        <Typography>Class roll number Generated</Typography>
                        {class_roll_number && classRoll_generate_date && <div className='ml-2 text-muted' style={{fontSize: '12px'}}><i>{`(${getDate(classRoll_generate_date)})`}</i></div>}
                    </TimelineContent>
                </TimelineItem>
                
            </Timeline>
        </div>
    );
}

export default StudentTimeline;